import { gql } from '@apollo/client';

export const FETCH_STRIPE_TOKEN = gql`
  mutation Flex_FetchStripeToken($accountId: Int!, $achMicrodepositVerification: Boolean!) {
    createSetupIntent(
      accountId: $accountId
      achMicrodepositVerification: $achMicrodepositVerification
    ) {
      stripeClientSecret
    }
  }
`;
